import { render, staticRenderFns } from "./Keyword.page.vue?vue&type=template&id=7f398eec&scoped=true"
import script from "./Keyword.page.vue?vue&type=script&lang=js"
export * from "./Keyword.page.vue?vue&type=script&lang=js"
import style0 from "./Keyword.page.vue?vue&type=style&index=0&id=7f398eec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f398eec",
  null
  
)

export default component.exports